import axios from "./axios";

export default {
  namespaced: true,

  state: {
    codeInfo: '',
  },
  getters: {
    gCodeInfo(state) {
      return state.codeInfo
    },
  },
  actions: {
    aQrCode({ rootGetters, dispatch, commit, rootState }) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token
          axios.get('profile/qrcode/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              if (response.data.status) {
                commit('mQrCode', response.data.data);
                resolve(1);
              } else if (response.data.message == "Unauthenticated") {
                //kill everything and move to login page
                dispatch("userauth/aAuthenticated", response.data.message, {root: true});
                resolve(0);
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    aChangeCode({ rootGetters, commit, rootState }) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token
          axios.put('profile/qrcode/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              commit('mChangeCode', response.data.message);
              commit('mQrCode', response.data.data);
              resolve(true)
            })
            .catch(error => {
              reject(error)
            })
        })
      }

    },
  },
  mutations: {
    mQrCode(state, info) {
      state.codeInfo = info
    },
    mChangeCode(state, info) {
      state.codeStatus = info
    },
  }
}